import { render, staticRenderFns } from "./GAuthPasswordField.vue?vue&type=template&id=47872c2a&scoped=true&"
import script from "./GAuthPasswordField.vue?vue&type=script&lang=ts&"
export * from "./GAuthPasswordField.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthPasswordField.vue?vue&type=style&index=0&id=47872c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47872c2a",
  null
  
)

export default component.exports